import React from 'react';
import Icon from '../shared/Icon.tsx';
import {
    ArrowDownIcon,
    BoxIcon,
    CodeIcon,
    CopyIcon,
    DownloadIcon,
    HeadingIcon,
    HeadphonesIcon,
    ImageIcon,
    PlayIcon,
    TextAlignStartIcon
} from 'lucide-react';
import {ChalkboardIcon, ShareSquareIcon} from '../shared/customIcons.ts';
import {ContentSectionType} from '../../api/types.ts';

interface SectionIconProps {
    sectionType: ContentSectionType;
}

const SectionIcon: React.FC<SectionIconProps> = ({sectionType}) => {
    switch (sectionType) {
        case ContentSectionType.Markdown:
            return (
                <span>
                    <b>M</b> <Icon icon={ArrowDownIcon} />
                </span>
            );
        case ContentSectionType.Code:
            return <span>{'{}'}</span>;
        case ContentSectionType.Html:
            return <Icon icon={CodeIcon} />;
        case ContentSectionType.Video:
            return <Icon icon={PlayIcon} />;
        case ContentSectionType.Picture:
            return <Icon icon={ImageIcon} />;
        case ContentSectionType.Audio:
            return <Icon icon={HeadphonesIcon} />;
        case ContentSectionType.Header:
            return <Icon icon={HeadingIcon} />;
        case ContentSectionType.Model:
            return <Icon icon={BoxIcon} />;
        case ContentSectionType.RichText:
            return <Icon icon={TextAlignStartIcon} />;
        case ContentSectionType.Download:
            return <Icon icon={DownloadIcon} />;
        case ContentSectionType.Copy:
            return <Icon icon={CopyIcon} />;
        case ContentSectionType.Embed:
            return <Icon icon={ShareSquareIcon} />;
        case ContentSectionType.Projects:
            return <Icon icon={ChalkboardIcon} />;
        default:
            return <Icon icon={TextAlignStartIcon} />;
    }
};

export default SectionIcon;
